<template>
  <v-app>
    <v-main class="main-bg d-flex align-center text-center">
      <v-progress-circular
        :width="5"
        :size="50"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-main>
  </v-app>
</template>
  
<script>
import { mapGetters } from "vuex";
import { DETAIL, LPA_DETAIL } from "@/router/constant";
// import {
//     SET_TOKEN,
//   } from '@/store/actions/auth';

export default {
  computed: {
    ...mapGetters(["accessToken", "payload", "system"]),
  },
  created() {
    const tokenPayload = this.$store.getters.payload;
    // console.log('tokenPayload.BookingId', tokenPayload.BookingId);
    console.log('this.system', this.system);

    const pageName = this.system === "lpa" ? LPA_DETAIL : DETAIL;

    setTimeout(()=>{
      // this.$router.push({ name: DETAIL });
      // this.$router.push({ name: ANNOUNCEMENT_DETAIL, query: { type } });
      this.$router.push({ name: pageName, params: {
        // env: this.system,
        id: tokenPayload.BookingId 
      }, query: { token: this.$route.query.token }  });
    }, 2000 )

    // console.log('token', this.$store.getters.error);
    // console.log('payload', this.$store.getters.payload);
    // this.$store.dispatch(SET_TOKEN, { token: '555', payload: {
    //   test: 'sdfdsf'
    // } });
  },
  methods: {

  },
};
</script>